import React from "react";
import load_img from "../../img/big-load.gif";

class Submit extends React.Component {
  childHandleClick = e => {
    this.props.submitClick();
  };
  render() {
    if (this.props.load === true) {
      return (
        <center>
          <img src={load_img} width="100" alt="img" />
        </center>
      );
    } else {
      return (
        <button
          type="button"
          className="btn btn-primary"
          onClick={this.childHandleClick}
          disabled={this.props.status}
        >
          Salvar
        </button>
      );
    }
  }
}

export default Submit;
